export default __webpack_public_path__ + "static/media/logo_corn.27477c84.svg";